"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FirebaseAPI = require("./FirebaseAPI");
var FirestorePager = require("../filters/FirestorePager");
var DataFilter = require("../filters/DataFilter");
var MAX_BATCH_SIZE = 500;
module.exports = /*#__PURE__*/function (_FirebaseAPI) {
  (0, _inherits2["default"])(FirestoreDB, _FirebaseAPI);
  var _super = _createSuper(FirestoreDB);
  function FirestoreDB(firebase, fbPathsConfig, baseUrl, plainToClassHook, classToPlainHook, classTransformOptions) {
    var _this;
    (0, _classCallCheck2["default"])(this, FirestoreDB);
    _this = _super.call(this, firebase, fbPathsConfig, baseUrl, plainToClassHook, classToPlainHook, classTransformOptions);
    _this.firebase = firebase;
    _this.firestore = firebase.firestore();
    _this.FieldValue = _this.firestore.FieldValue || firebase.firestore.FieldValue;
    _this.FieldPath = _this.firestore.FieldPath || firebase.firestore.FieldPath;
    _this.AggregateField = _this.firestore.AggregateField || firebase.firestore.AggregateField;
    return _this;
  }
  (0, _createClass2["default"])(FirestoreDB, [{
    key: "fieldValueDelete",
    value: function fieldValueDelete() {
      return this.FieldValue["delete"]();
    }
  }, {
    key: "fieldValueArrayRemove",
    value: function fieldValueArrayRemove() {
      var _this$FieldValue;
      return (_this$FieldValue = this.FieldValue).arrayRemove.apply(_this$FieldValue, arguments);
    }
  }, {
    key: "fieldValueArrayUnion",
    value: function fieldValueArrayUnion() {
      var _this$FieldValue2;
      return (_this$FieldValue2 = this.FieldValue).arrayUnion.apply(_this$FieldValue2, arguments);
    }
  }, {
    key: "fieldValueIncrement",
    value: function fieldValueIncrement(n) {
      return this.FieldValue.increment(Number(n));
    }
  }, {
    key: "fieldValueServerTimestamp",
    value: function fieldValueServerTimestamp() {
      return this.FieldValue.serverTimestamp();
    }
  }, {
    key: "fieldPathDocumentId",
    value: function fieldPathDocumentId() {
      return this.FieldPath.documentId();
    }
  }, {
    key: "getGroupRef",
    value: function getGroupRef(path) {
      return this.getDb().collectionGroup(path);
    }
  }, {
    key: "getRef",
    value: function getRef(path) {
      var split = path.split("/");
      var ref = this.getDb();
      if (split.length % 2 === 0) {
        ref = ref.doc(path);
      } else {
        ref = ref.collection(path);
      }
      return ref;
    }
  }, {
    key: "getRefForMethodName",
    value: function getRefForMethodName(methodName, parsedPath) {
      var ref;
      if (methodName.endsWith("GroupPager") || methodName.endsWith("GroupRef") || methodName.endsWith("Group")) {
        ref = this.getGroupRef(parsedPath);
      } else {
        ref = this.getRef(parsedPath);
      }
      return ref;
    }
  }, {
    key: "getDb",
    value: function getDb() {
      return this.firestore;
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(ref, clazz, options) {
        var doc;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return ref.get();
            case 2:
              doc = _context.sent;
              return _context.abrupt("return", this.resToData(doc, clazz, options));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetch(_x, _x2, _x3) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "aggregationCount",
    value: function () {
      var _aggregationCount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(ref, options) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this._aggregateInternal(ref, undefined, this.AggregateField.count, options));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function aggregationCount(_x4, _x5) {
        return _aggregationCount.apply(this, arguments);
      }
      return aggregationCount;
    }()
  }, {
    key: "aggregationAverage",
    value: function () {
      var _aggregationAverage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(ref, options) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this._aggregateInternal(ref, options.aggregateBy, this.AggregateField.average, options));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function aggregationAverage(_x6, _x7) {
        return _aggregationAverage.apply(this, arguments);
      }
      return aggregationAverage;
    }()
  }, {
    key: "aggregationSum",
    value: function () {
      var _aggregationSum = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(ref, options) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this._aggregateInternal(ref, options.aggregateBy, this.AggregateField.sum, options));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function aggregationSum(_x8, _x9) {
        return _aggregationSum.apply(this, arguments);
      }
      return aggregationSum;
    }()
  }, {
    key: "_aggregateInternal",
    value: function () {
      var _aggregateInternal2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(ref, fieldName, fn) {
        var options,
          snapshot,
          _snapshot$data,
          result,
          methodName,
          pathPostfix,
          _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : {};
              if (options.dataFilter) {
                ref = options.dataFilter.applyFilters(ref);
              }
              _context5.next = 4;
              return ref.aggregate({
                result: fn(fieldName)
              }).get();
            case 4:
              snapshot = _context5.sent;
              _snapshot$data = snapshot.data(), result = _snapshot$data.result;
              methodName = this.getMethodNameLog(options);
              if (!options.disableLogs) {
                pathPostfix = options.aggregateBy ? ": ".concat(options.aggregateBy) : "";
                this.log("FirestoreDB: result ".concat(methodName, "= "), result, ", path = ", this.getPathFromQuerySnapshot(snapshot, {
                  pathPostfix: pathPostfix
                }));
              }
              return _context5.abrupt("return", result);
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function _aggregateInternal(_x10, _x11, _x12) {
        return _aggregateInternal2.apply(this, arguments);
      }
      return _aggregateInternal;
    }()
  }, {
    key: "fetchList",
    value: function fetchList(ref, splitCommands, clazz, options) {
      var _this2 = this;
      //splitCommands = ["where('param1', ... ,'paramN'), where(...), limit(..), orderBy(...), etc"]
      // this.log("fetchList: splitCommands = ", splitCommands)
      // splitCommands.forEach(command => {
      //     let methodSplit = command.replace(")", "").split("(")
      //     let methodName = methodSplit[0]
      //     methodSplit.splice(0, 1)
      //     let args = methodSplit.split(",")
      //     // this.log("fetchList: methodName = ", methodName, ", args = ", args)
      //     ref = ref[methodName](args)
      // })
      return ref.get().then(function (res) {
        return _this2.resArrayToDataArray(res, clazz, options);
      });
    }
  }, {
    key: "createDefaultDataFilter",
    value: function createDefaultDataFilter(limit) {
      return new DataFilter(limit);
    }
  }, {
    key: "fetchListPager",
    value: function fetchListPager(ref) {
      var dataFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new DataFilter();
      var clazz = arguments.length > 2 ? arguments[2] : undefined;
      var options = arguments.length > 3 ? arguments[3] : undefined;
      return new FirestorePager(ref, dataFilter, clazz, this.resArrayToDataArray.bind(this), options);
    }
  }, {
    key: "classToPlainBefore",
    value: function classToPlainBefore(object) {
      var _this3 = this;
      // Firestore has special helper fields of type FiledValue.
      // We want to preserve them so excluding them from classToPlain conversion here
      // and applying those intact values back in the classToPlainAfter after the classToPlain was applied

      //Firestore doesn't support recursive FieldValues, so only searching them on a top level.
      //Commit eec8a227 has recursive search implementation in case firebase ever allows it in the future.

      // this.log("FirestoreDB: classToPlainBefore: ", object)

      var specialFunctions = ["arrayRemove", "arrayUnion", "increment", "deleteField", "serverTimestamp"];
      var fieldValueMap = {};
      Object.keys(object).forEach(function (key) {
        var value = object[key];
        if (_this3.isObjectOfType(value, ["FieldValue", "Qh", function (obj) {
          return obj._methodName && specialFunctions.includes(obj._methodName);
        }])) {
          _this3.log("FirestoreDB: classToPlainBefore: 'FieldValue' found for key '", key, "' - excluding it");
          fieldValueMap[key] = value;
          object[key] = null;
        }
      });
      return fieldValueMap;
    }
  }, {
    key: "isObjectOfType",
    value: function isObjectOfType(object, typeEvaluation) {
      while (object && object.constructor) {
        var constructorName = object.constructor.name;
        // this.log("FirestoreDB.isObjectOfType: constructorName = ", constructorName)
        var _iterator = _createForOfIteratorHelper(typeEvaluation),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var typeExpression = _step.value;
            if (typeof typeExpression === "function" && typeExpression(object)) {
              return true;
            } else if (constructorName === typeExpression) {
              return true;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        object = Object.getPrototypeOf(object);
      }
      return false;
    }
  }, {
    key: "classToPlainAfter",
    value: function classToPlainAfter(object, fieldValueMap) {
      var _this4 = this;
      Object.keys(fieldValueMap).forEach(function (key) {
        // this.log("classToPlainBefore: FieldValue found - applying it: fieldValueMap = ", fieldValueMap)
        object[key] = fieldValueMap[key];
        // this.setObjValueByPath(object, key, fieldValueMap[key])
        _this4.log("classToPlainAfter: FieldValue found - applying it: object = ", object, ", key = ", key, ", fieldValueMap[".concat(key, "] = "), fieldValueMap[key]);
      });
    }
  }, {
    key: "setObjValueByPath",
    value: function setObjValueByPath(object, path, value) {
      var pathSplit = this.splitPathUsingObj(path, object).filter(function (p) {
        return p;
      });
      this.log("setObjValueByPath: pathSplit = ", pathSplit, ", path = ", path, ", object = ", object);
      pathSplit.reduce(function (o, p, i) {
        return o[p] = pathSplit.length === ++i ? value : o[p] || {};
      }, object);
    }
  }, {
    key: "getObjValueByPath",
    value: function getObjValueByPath(object, path) {
      return this.splitPathUsingObj(path, object).filter(function (p) {
        return p;
      }).reduce(function (o, p) {
        return o ? o[p] : undefined;
      }, object);
    }
  }, {
    key: "getPropertyStartsWith",
    value: function getPropertyStartsWith(obj, prefix) {
      var props = [];
      var keysArray = Object.keys(obj);
      for (var i = 0; i < keysArray.length; ++i) {
        var key = keysArray[i];
        if (key.startsWith(prefix)) {
          props.push(key);
        }
      }
      return props;
    }
  }, {
    key: "splitPathUsingObj",
    value: function splitPathUsingObj(path, object) {
      var _this5 = this;
      this.log("======= splitPathUsingObj start: path = ", path, ", object = ", object);
      var splitPath = path.split(/[\.\[\]\'\"]/);
      var res = [];
      var fullPath;
      splitPath.reduce(function (o, p) {
        var subObject = {};
        var properties = _this5.getPropertyStartsWith(o, p);
        _this5.log("splitPathUsingObj: properties = ", properties, ", p = ", p, ", fullPath = ", path, ", object = ", o);
        fullPath = fullPath ? "".concat(fullPath, ".").concat(p) : p;
        // let fullPathTmp = fullPath
        properties.forEach(function (prop) {
          // let fullPath = fullPath ? `${fullPath}.${p}` : p
          if (prop === p && o[p]) {
            if ((0, _typeof2["default"])(o[p]) === "object") {
              subObject = _objectSpread(_objectSpread({}, subObject), o[p]);
            }
            res.push(fullPath);
            fullPath = "";
            _this5.log("splitPathUsingObj: found value. prop = ", prop, ", o = ", o);
          } else {
            var subProperty = prop.substring(p.length + 1);
            subObject[subProperty] = o[prop];
            _this5.log("splitPathUsingObj: no value found. prop = ", prop, ", subProperty = ", subProperty, ", o = ", o);
          }
        });
        // fullPath = fullPathTmp
        _this5.log("splitPathUsingObj: subObject = ", subObject);
        return subObject;
      }, object);
      this.log("======= splitPathUsingObj: res = ", res, ", path = ", path, ", object = ", object);
      return res;
    }
  }, {
    key: "create",
    value: function create(ref, object, clazz, options) {
      var methodName = this.getMethodNameLog(options) || "create ";
      var objJson = this.toObjJson(object, ref, options);
      this.log("FirestoreDB: ".concat(methodName, "result = "), object, ", path = ", ref.path);
      return ref.set(objJson).then(function (_) {
        return object;
      });
    }
  }, {
    key: "transaction",
    value: function () {
      var _transaction = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(ref, dataCallback, clazz, transactionCallback, options) {
        var _this6 = this;
        var transactionRetryCount;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              transactionRetryCount = 1;
              return _context7.abrupt("return", this.firestore.runTransaction( /*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(transaction) {
                  var msg, doc, data, objJson;
                  return _regenerator["default"].wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        msg = "FirestoreDb: " + transactionRetryCount > 1 ? "transaction retry #".concat(transactionRetryCount) : "transaction started";
                        _this6.log(msg);
                        _context6.next = 4;
                        return transaction.get(ref);
                      case 4:
                        doc = _context6.sent;
                        data = _this6.resToData(doc, clazz, options);
                        _context6.next = 8;
                        return dataCallback(data);
                      case 8:
                        data = _context6.sent;
                        objJson = _this6.toObjJson(data, ref, options);
                        _context6.next = 12;
                        return transactionCallback(transaction, ref, objJson);
                      case 12:
                        transactionRetryCount++;
                        return _context6.abrupt("return", data);
                      case 14:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x18) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function transaction(_x13, _x14, _x15, _x16, _x17) {
        return _transaction.apply(this, arguments);
      }
      return transaction;
    }()
  }, {
    key: "transactionUpdate",
    value: function () {
      var _transactionUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(ref, dataCallback, clazz, options) {
        var _this7 = this;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.transaction(ref, dataCallback, clazz, /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(transaction, ref, objJson) {
                  var methodName;
                  return _regenerator["default"].wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        methodName = _this7.getMethodNameLog(options) || "transactionUpdate ";
                        _this7.log("FirestoreDb: ".concat(methodName, ": objJson = "), objJson);
                        _context8.next = 4;
                        return transaction.update(ref, objJson);
                      case 4:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x23, _x24, _x25) {
                  return _ref2.apply(this, arguments);
                };
              }(), options);
            case 2:
              return _context9.abrupt("return", _context9.sent);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function transactionUpdate(_x19, _x20, _x21, _x22) {
        return _transactionUpdate.apply(this, arguments);
      }
      return transactionUpdate;
    }()
  }, {
    key: "transactionSet",
    value: function () {
      var _transactionSet = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(ref, dataCallback, clazz, options) {
        var _this8 = this;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.transaction(ref, dataCallback, clazz, /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(transaction, ref, objJson) {
                  var methodName;
                  return _regenerator["default"].wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        methodName = _this8.getMethodNameLog(options) || "transactionSet ";
                        _this8.log("FirestoreDb: ".concat(methodName, ": objJson = "), objJson);
                        _context10.next = 4;
                        return transaction.set(ref, objJson, {
                          merge: true
                        });
                      case 4:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x30, _x31, _x32) {
                  return _ref3.apply(this, arguments);
                };
              }(), options);
            case 2:
              return _context11.abrupt("return", _context11.sent);
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function transactionSet(_x26, _x27, _x28, _x29) {
        return _transactionSet.apply(this, arguments);
      }
      return transactionSet;
    }()
  }, {
    key: "update",
    value: function update(ref, object, clazz, options) {
      var methodName = this.getMethodNameLog(options) || "update ";
      var objJson = this.toObjJson(object, ref, options);
      this.log("FirestoreDb: ".concat(methodName, ": objJson = "), objJson, ", path = ", ref.path, ", original object = ", object);
      return ref.update(objJson).then(function (_) {
        return object;
      });
    }
  }, {
    key: "set",
    value: function set(ref, object, clazz) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var merge = options.merge !== undefined ? options.merge : true;
      var methodName = this.getMethodNameLog(options) || "set ";
      var objJson = this.toObjJson(object, ref, options);
      this.log("FirestoreDb: ".concat(methodName, ": objJson = "), objJson, ", path = ", ref.path, ", original object = ", object);
      return ref.set(objJson, {
        merge: merge
      }).then(function (_) {
        return object;
      });
    }
  }, {
    key: "delete",
    value: function _delete(ref, object, clazz, options) {
      var methodName = this.getMethodNameLog(options) || "delete ";
      this.log("FirestoreDb: ".concat(methodName, ": data = "), object, ", path = ", ref.path);
      return ref["delete"]().then(function (_) {
        return object;
      });
    }
  }, {
    key: "deleteAll",
    value: function () {
      var _deleteAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(ref) {
        var dataFilter,
          clazz,
          options,
          methodName,
          totalCount,
          pager,
          dataArray,
          _args12 = arguments;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              dataFilter = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : new DataFilter();
              clazz = _args12.length > 2 ? _args12[2] : undefined;
              options = _args12.length > 3 ? _args12[3] : undefined;
              methodName = this.getMethodNameLog(options) || "deleteAll ";
              totalCount = 0;
              pager = this.fetchListPager(ref, dataFilter, clazz, options);
            case 6:
              if (!pager.hasMore) {
                _context12.next = 15;
                break;
              }
              _context12.next = 9;
              return pager.next();
            case 9:
              dataArray = _context12.sent;
              totalCount += dataArray.length;
              _context12.next = 13;
              return this.batchDelete(ref, dataArray, clazz);
            case 13:
              _context12.next = 6;
              break;
            case 15:
              this.log("FirestoreDb: ".concat(methodName, ": deleted "), totalCount, " item(s)");
              return _context12.abrupt("return", totalCount);
            case 17:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function deleteAll(_x33) {
        return _deleteAll.apply(this, arguments);
      }
      return deleteAll;
    }()
  }, {
    key: "toObjJson",
    value: function toObjJson(object, ref, options) {
      this.ensureIdSet(object, ref);
      if (object && typeof object.beforeSaveToDb === "function") {
        object = object.beforeSaveToDb(options) || object;
      }
      var objJson = this.classToPlainHook(object);
      return objJson;
    }
  }, {
    key: "onSnapshot",
    value: function onSnapshot(ref, clazz, callback, options) {
      var _this9 = this;
      var observer;
      var deferCall = function deferCall(fn) {
        if (!observer) {
          setTimeout(function () {
            return deferCall(fn);
          }, 1);
        } else {
          fn();
        }
      };
      observer = ref.onSnapshot(function (docSnapshot) {
        var data = _this9.resToData(docSnapshot, clazz, options);
        deferCall(function () {
          return callback(data);
        });
      }, function (error) {
        return deferCall(function () {
          return callback(null, error);
        });
      });
      return observer;
    }
  }, {
    key: "batch",
    value: function () {
      var _batch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(collectionRef, objectList, callback, options) {
        var _this10 = this;
        var batches, batch, count;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              batches = [];
              batch = this.firestore.batch();
              count = 0;
              objectList.forEach(function (object) {
                if (count >= MAX_BATCH_SIZE) {
                  batches.push(batch.commit());
                  batch = _this10.firestore.batch();
                  _this10.log("FirestoreDB batch: max batch size of ".concat(MAX_BATCH_SIZE, " reached. Creating a new batch..."));
                  count = 0;
                }
                var jsonObj = _this10.toObjJson(object, options);
                var objRef = collectionRef.doc(object[_this10.idName]);
                callback(batch, objRef, jsonObj);
                count++;
              });
              if (count !== 0) {
                batches.push(batch.commit());
              }
              this.log("FirestoreDB: batches = ", batches);
              return _context13.abrupt("return", Promise.all(batches));
            case 7:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function batch(_x34, _x35, _x36, _x37) {
        return _batch.apply(this, arguments);
      }
      return batch;
    }()
  }, {
    key: "batchUpdate",
    value: function batchUpdate(collectionRef, objectList, clazz, options) {
      return this.batch(collectionRef, objectList, function (batch, objRef, jsonObj) {
        batch.update(objRef, jsonObj);
      }, options);
    }
  }, {
    key: "batchCreate",
    value: function batchCreate(collectionRef, objectList, clazz, options) {
      return this.batch(collectionRef, objectList, function (batch, objRef, jsonObj) {
        batch.add(objRef, jsonObj);
      }, options);
    }
  }, {
    key: "batchSet",
    value: function batchSet(collectionRef, objectList, clazz, options) {
      return this.batch(collectionRef, objectList, function (batch, objRef, jsonObj) {
        batch.set(objRef, jsonObj, {
          merge: true
        });
      }, options);
    }
  }, {
    key: "batchDelete",
    value: function batchDelete(collectionRef, objectList, clazz, options) {
      this.log("batchDelete: objectList = ", objectList);
      return this.batch(collectionRef, objectList, function (batch, objRef, jsonObj) {
        batch["delete"](objRef);
      }, options);
    }
  }, {
    key: "generateId",
    value: function generateId(length) {
      var col = this.getDb().collection("genId");
      var id = col.doc().id;
      if (length && length > 0) {
        while (id.length < length) {
          id += col.doc().id;
        }
        id = id.substring(0, length);
      }
      return id;
    }
  }, {
    key: "resToData",
    value: function resToData(snapshot, clazz) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var methodName = this.getMethodNameLog(options);
      var data = clazz ? this.plainToClassHook(clazz, snapshot.data(), options) : snapshot.data();
      if (data && !data[this.idName]) {
        data[this.idName] = snapshot.id;
      }
      if (options.includeSnapshot) {
        var snapshotField = options.snapshotField || "_snapshot";
        data[snapshotField] = snapshot;
      }
      if (!options.disableLogs) {
        this.log("FirestoreDB: result ".concat(methodName, "= "), data, ", path = ", this.getPathFromQuerySnapshot(snapshot));
      }
      return data;
    }
  }, {
    key: "resArrayToData",
    value: function resArrayToData(res, clazz, options) {
      var methodName = this.getMethodNameLog(options);
      var doc = res.docs[0];
      var data = doc ? doc.data() : null;
      var obj = data ? this.plainToClassHook(clazz, data, options) : null;
      this.log("FirestoreDB: result ".concat(methodName, "= "), obj, ", path = ", this.getPathFromQuerySnapshot(res));
      return obj;
    }
  }, {
    key: "resArrayToDataArray",
    value: function resArrayToDataArray(res, clazz) {
      var _this11 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var methodName = this.getMethodNameLog(options);
      var data = res.docs.map(function (doc) {
        return _this11.resToData(doc, clazz, _objectSpread({
          disableLogs: true
        }, options));
      });
      this.log("FirestoreDB: result ".concat(methodName, "= "), data, ", path = ", this.getPathFromQuerySnapshot(res));
      return data;
    }
  }, {
    key: "getMethodNameLog",
    value: function getMethodNameLog() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var methodName = options.methodName;
      if (methodName) {
        var args = [];
        if (options.args && options.args.length) {
          args = options.args;
        }
        return "".concat(methodName, "(").concat(args.join(","), ") ");
      }
      return "";
    }
  }, {
    key: "getPathFromQuerySnapshot",
    value: function getPathFromQuerySnapshot(snapshot) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$pathPostfix = options.pathPostfix,
        pathPostfix = _options$pathPostfix === void 0 ? "" : _options$pathPostfix;
      var path;
      if (snapshot.ref && snapshot.ref.path) {
        path = snapshot.ref.path;
      } else if (snapshot.query) {
        if (snapshot.query.path) {
          path = snapshot.query.path;
        } else if (snapshot.query._queryOptions) {
          var _options = snapshot.query._queryOptions;
          path = _options.parentPath.relativeName + "/" + _options.collectionId;
        } else if (snapshot.query._query && snapshot.query._query.path && snapshot.query._query.path.segments) {
          path = snapshot.query._query.path.segments.join("/");
        }
      }
      if (path && !path.endsWith(pathPostfix)) {
        path += pathPostfix;
      }
      if (!path) {
        this.log("getPathFromQuerySnapshot: result is null. Snapshot = ", snapshot);
      }
      return path;
    }
  }]);
  return FirestoreDB;
}(FirebaseAPI);